export default {
  port: process.env.PORT || 3000,
  url: process.env.APP_URL || 'http://localhost:3000',
  ssrUrl: process.env.SSR_URL || 'http://localhost:3000',
  remoteHotReload: false,
  cookieSecret: 'F}6;S)E0x58J5qdMJc<%81&zoVUyJ5Z,Z^;OB4PNtL6V?K#ie1`3f5/>3F"s&t',
}





// WEBPACK FOOTER //
// ./src/server/localConfig.js